var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { media__modal: _vm.isModel } }, [
    _vm.type == "image"
      ? _c("div", { staticClass: "media__image" }, [
          _vm.item && _vm.item.imageURL
            ? _c("img", {
                attrs: { src: _vm.item.imageURL, alt: "media image" }
              })
            : _c("span", [_c("i", { staticClass: "far fa-image" })])
        ])
      : _vm._e(),
    _vm._v(" "),
    ["webGl"].includes(_vm.type)
      ? _c(
          "div",
          { staticClass: "media__viewer" },
          [
            _vm.item && _vm.item.fileURL
              ? _c("WebGlViewer", {
                  attrs: { item: _vm.items, src: _vm.item.fileURL }
                })
              : _c("span", [_c("i", { staticClass: "far fa-image" })])
          ],
          1
        )
      : ["glb", "gltf"].includes(_vm.type)
      ? _c(
          "div",
          { staticClass: "media__viewer" },
          [
            _vm.item && _vm.item.fileURL
              ? _c("model-viewer", { attrs: { src: _vm.item.fileURL } })
              : _c("span", [_c("i", { staticClass: "far fa-image" })])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type == "video"
      ? _c("div", { staticClass: "media__video" }, [
          _vm.item && _vm.item.videoURL && !_vm.isModel
            ? _c(
                "video",
                { attrs: { poster: _vm.poster ? _vm.poster : null } },
                [
                  _c("source", {
                    attrs: { src: _vm.item.videoURL, type: "video/mp4" }
                  })
                ]
              )
            : _c("video", { attrs: { controls: "", autoplay: "" } }, [
                _c("source", {
                  attrs: { src: _vm.item.videoURL, type: "video/mp4" }
                })
              ]),
          _vm._v(" "),
          !_vm.item && !_vm.item.videoURL
            ? _c("span", [
                _vm._v(" >"),
                _c("i", { staticClass: "far fa-image" })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isModel
            ? _c("span", { staticClass: "play__icon" }, [
                _c("i", { staticClass: "fas fa-play" })
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == "audio"
      ? _c(
          "div",
          { staticClass: "media__audio", style: "--audio : " + _vm.color },
          [
            _vm.item && _vm.item.audioURL
              ? _c("audio", {
                  ref: "audio",
                  attrs: { controls: "", src: _vm.item.audioURL },
                  on: { play: _vm.play, pause: _vm.pause }
                })
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0665b330", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0665b330","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Media.vue
// module id = null
// module chunks = 